import { StripePrice } from '~/subscription/types/subscription.types'

// The Knowit partner price rides along in the geo price list; it is never a standard price to quote or compare.
export const isKnowItPrice = (price?: StripePrice): boolean => price?.metadata?.isKnowIt === 'true'

/** The geo price list with Knowit's price removed from every array in it. */
export function withoutKnowItPrices(pricesObj: any): any {
  if (!pricesObj || typeof pricesObj !== 'object') return pricesObj
  return Object.fromEntries(
    Object.entries(pricesObj).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.filter((entry: any) => !isKnowItPrice(entry?.price)) : value,
    ]),
  )
}
